<!-- eslint-disable -->
<template>
    <el-container>
        <el-row class="list-container">
            <el-col :span="24">
                <el-button @click="refreshData" type="primary" size="small" icon="iconfont icon-shuaxin shuaxin">刷新</el-button>
            </el-col>

            <!-- search start  -->
            <el-col :span="24" class="search-content">
                <div class="search-item">
                    <el-input v-model="data.goods_title" size="small" placeholder="请输入商品标题" clearable></el-input>
                </div>
                <div class="search-item">
                    <el-input v-model="data.staff_name" size="small" placeholder="请输入核销员工" clearable></el-input>
                </div>
                <div class="search-item">
                    <el-input v-model="data.order_no" size="small" placeholder="请输入商品订单编号" clearable></el-input>
                </div>
                <div class="search-item">
                    <el-button size="small" icon="iconfont icon-fangdajing shuaxin" @click="search">搜索</el-button>
                </div>
            </el-col>
            <!-- search end  -->

            <el-col class="main-content">
                <el-table :data="dataList" border @selection-change="handleSelectionChange" v-loading="loading" style="width: 100%">
                    <el-table-column prop="id" label="ID" width="80"></el-table-column>

                    <el-table-column prop="goods_title" label="商品标题" width="300"></el-table-column>
                    <el-table-column prop="staff_name" label="核销员工" width="180"></el-table-column>
                    <el-table-column prop="order_no" label="商品订单编号" width="180"></el-table-column>
                    <el-table-column prop="goods_num" label="商品数量" width="120"></el-table-column>
                    <el-table-column prop="goods_money" label="商品价格" width="120"></el-table-column>
                    <el-table-column prop="created_at" label="核销时间" min-width="180"></el-table-column>
                </el-table>
            </el-col>
            <el-col class="pagination">
                <el-pagination
                    @current-change="changePage"
                    @size-change="changePageSize"
                    background
                    :layout="pageLayout"
                    :page-sizes="pagePageSizes"
                    :page-size="pagePageSize"
                    :total="totalCount"
                    :current-page.sync="current_page"
                    :hide-on-single-page="false">
                </el-pagination>
            </el-col>
        </el-row>

    </el-container>
</template>

<!-- eslint-disable -->
<script>
    import {GoodsOrderVerifyIndex} from "@/utils/request.js"
    import {mapState} from "vuex"

    export default {
        data(){
            return {
                data: {
                    page: 1,
                    page_size: this.pagePageSize,
                    staff_name: '',
                    goods_title: '',
                    order_no: '',
                },
                loading: false,
                dataList: [],
                totalCount: 0,
                current_page: 1,
                dialogFormVisible: false,
                loadingAdd: false,
                dialogTitle: "新增XXX",
                formLabelWidth: "120px",
                form: {
                    id: 0,
                    staff_name: "",
                },
                multipleSelection: [],
            }
        },
        created() {
            this.getList()
        },
        computed: mapState(["power"]),
        methods: {
            search() {
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            refreshData() {
                this.data.page = 1
                this.current_page = 1
                this.loading = true

                this.getList()
            },
            getList() {
                this.loading = true
                GoodsOrderVerifyIndex(this.data).then((res) => {
                    if (res.code == 200) {
                        this.data.page++
                        this.dataList = res.data.data
                        this.totalCount = res.data.count
                    } else {
                        this.$message.error("数据获取失败!")
                    }
                    this.loading = false
                })
            },
            changePage(page) {
                this.data.page = page
                this.getList()
            },
            changePageSize(size) {
                this.data.page_size = size
                this.data.page = 1
                this.current_page = 1
                this.getList()
            },
            handleSelectionChange(val) {
                this.multipleSelection = []
                if (val.length > 0) {
                    val.filter((item) => {
                        this.multipleSelection.push(item.id)
                    })
                }
            },

        }
    }
</script>

<style>
</style>
